const state = {
	status: false,
};

const getters = {
	status: state => state.status,
};

const mutations = {
	status(state, bool) {
		state.status = bool;
	},
};

const actions = {
	start({commit}) {
		commit('status', true);
	},
	stop({commit}) {
		commit('status', false);
	},
};


export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
}